/**
 * Internal dependencies
 */
import { MEDIA_NOT_DEFINED, STATE_NOT_READY } from './constants';
export function getMediaSources(state) {
  return state.sources;
}
export function getMediaSourceById(state, id) {
  var _state$sources;

  if (id === MEDIA_NOT_DEFINED) {
    return;
  }

  return (_state$sources = state.sources) === null || _state$sources === void 0 ? void 0 : _state$sources[id];
}
/**
 * Retunr the default media source.
 * - the default one in case it's defined.
 * - the first one in case there are sources defined
 * - null when no media sources :-o
 *
 * @param {Object} state
 * @return {string|null} default media source ID.
 */

export function getDefaultMediaSource(state) {
  let playerId = null;
  const keys = Object.keys(state.sources);

  if (state.default) {
    playerId = state.default;
  } else if (keys !== null && keys !== void 0 && keys.length) {
    playerId = state.sources[keys[0]].id;
  }

  if (!playerId) {
    return;
  }

  return state.sources[playerId];
}
export function getMediaPlayerState(state, id) {
  var _state$sources2;

  const defaultMediaSource = id ? (_state$sources2 = state.sources) === null || _state$sources2 === void 0 ? void 0 : _state$sources2[id] : getDefaultMediaSource(state);

  if (!(defaultMediaSource !== null && defaultMediaSource !== void 0 && defaultMediaSource.state)) {
    return STATE_NOT_READY;
  }

  return defaultMediaSource.state;
}
export function getMediaSourceCurrentTime(state, id) {
  var _state$sources3;

  const defaultMediaSource = id ? (_state$sources3 = state.sources) === null || _state$sources3 === void 0 ? void 0 : _state$sources3[id] : getDefaultMediaSource(state);
  return defaultMediaSource === null || defaultMediaSource === void 0 ? void 0 : defaultMediaSource.currentTime;
}
export function getMediaSourceDuration(state, id) {
  var _state$sources4, _state$sources4$id;

  if (!id) {
    const defaultMediaSource = getDefaultMediaSource(state);
    return defaultMediaSource === null || defaultMediaSource === void 0 ? void 0 : defaultMediaSource.duration;
  }

  return (_state$sources4 = state.sources) === null || _state$sources4 === void 0 ? void 0 : (_state$sources4$id = _state$sources4[id]) === null || _state$sources4$id === void 0 ? void 0 : _state$sources4$id.duration;
}
export function getMediaSourceDomReference(state, id) {
  var _state$sources5;

  const mediaSource = id ? (_state$sources5 = state.sources) === null || _state$sources5 === void 0 ? void 0 : _state$sources5[id] : getDefaultMediaSource(state);

  if (!mediaSource) {
    return;
  }

  if (!(mediaSource !== null && mediaSource !== void 0 && mediaSource.querySelector)) {
    return;
  }

  return document.querySelector(mediaSource.querySelector);
}
//# sourceMappingURL=selectors.js.map